import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {makeUiMainProjectList, isMultipleEmailsValid} from "../prodect/ProsCommonUi";
import {
    prosNotificationShow, prosPopupClose, prosPopupCloseAll,
    prosPopupOpen,
    prosPopupOpenDynamic, prosPopupRender,
} from "../prodect/ProsPopup";
import {
    ATTR_AWS_PROJECT_ID,
    ATTR_CUSTOMER_GROUP,
    ATTR_IS_TEMPLATE,
    ATTR_MAIN_PROJECT_NAME,
    ATTR_TEXT,
    OBJ_STATE_PAS,
    PROJECT_NAME_MAX_LEN,
    PROJECT_NAME_MIN_LEN,
    STR_YES,
    ATTR_PROJECT_STATE,
    ATTR_LICENSE_LEVEL,
    getProjectObjs,
    getObjAttr,
    getUserTemplateProjects, ATTR_PRJ_DESC, UI_LISTED_ELEMENTS_LIMIT
} from "../prodect/ProsConnect";
import {awaitMakeNewProject} from "../prodect/ProjectManagement";
import {setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import DropdownMenu from "../components/DropdownMenu";
import TextInput from "../components/TextInput";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import RadioButton from "../components/RadioButton";
import ToggleSwitch from "../components/ToggleSwitch";
import Spacer from "../components/Spacer";
import Checkbox from "../components/Checkbox";
import prosAppNotif from "../prodect/ProsAppNotif";

const MODE_ONE_TEMPLATE_SUB_PROJECT = 1
const MODE_ONE_OR_MORE_SUB_PROJECTS = 2
const MODE_MY_PRODECT = 3

export default class CreateSubProject extends Component {
    constructor(props) {
        super(props);
        this.pollTimer = undefined
        this.mounted = true
        this.mainProjectName = undefined
        this.customerGroup = undefined
        this.createModeForPopup = undefined
        this.state = {
            isLoading: true,
            isSavingNewProject: false,
            projectName: '',
            projectDesc: '',
            copyContentFrom: "",
            templateProjectId: undefined,
            projectTemplates: [],
            mainProjectList: undefined,
            filterProjectForRef: '',
            filterProjectToCopyUsers: '',
            selectedMainProjectIndex: 0,            // main project to copy settings (+ opt more)
            selectedUserProjectIndex: 0,            // main project to copy users
            newSubProjects: [],                     // [{projectId: <string>, newName: <string>]}
            selectedUserProjectToMakeNewId: undefined,
            copyReports: true,
            copyObs: true,
            copyOtherUsers: false,
            subProjectReadyInServer: false
        }

        this.newSubProjectId = null
    }
    /*
     * Modes
     *  1- create one new subproject using template: this.state.copyContentFrom === 'template'
     *  2- create one or more subprojects using other sub-projects as a ref: this.state.copyContentFrom === 'project'
     *  3- Superuser creating one or more MyProdect projects providing email list in project name
     *      ref isMyProdectForMultipleUsers()
     *     Later use this only to create MyProdect for Ains internal users
     *     Customers would in future select service level when ordering a project
     */

    async componentDidMount() {
        this.mounted = true
        let refProject = this.props.refProjectAttrs
        // Get project list with an extra "selection title" with index 0 to filter projects
        let mainProjectList = await makeUiMainProjectList('all', 'Valitse pääprojekti')
        if (refProject) {
            // Use selected main project by default as a reference for new project
            let mainProjectName = refProject[ATTR_MAIN_PROJECT_NAME]
            let customerGroup = refProject[ATTR_CUSTOMER_GROUP]
            let selectedMainProjectIndex = mainProjectList
                .findIndex(mp =>
                    mp.name.toUpperCase() === mainProjectName.toUpperCase() &&
                    mp.customerGroup === customerGroup)
            if (selectedMainProjectIndex >= 0) {
                this.setState({
                    selectedMainProjectIndex: selectedMainProjectIndex,
                    selectedUserProjectIndex: selectedMainProjectIndex
                })
            }
        }
        this.getTemplateProjects()
        this.setState({
            isLoading: false,
            mainProjectList: mainProjectList
        })
        setHelpContext('newProject')
    }

    componentWillUnmount() {
        this.mounted = false
        this.stopPollingSubProjectReady(this)
        prosPopupCloseAll()
    }

    async getTemplateProjects() {
        let projectTemplates = await prosConnect.getProjectTemplates()
        let projectTemplatePids = projectTemplates.map(item => item.id)
        let projectTemplateProjects = await getProjectObjs(projectTemplatePids)
        const userTemplateProjectsPids = getUserTemplateProjects(projectTemplatePids).map(project => project.project_id)
        const userTemplateProjects = await getProjectObjs(userTemplateProjectsPids)
        this.setState({
            projectTemplates: projectTemplateProjects,
            userTemplateProjects: userTemplateProjects,
            templateProjectId: projectTemplates.length ? projectTemplates[0].id : undefined
        })
    }

    pollBusy = false
    async pollSubProjectReady() {
        // after sub-project been created poll when that is available in server
        if (this.pollBusy) {
            prosConnect.prosLog('pollSubProjectReady() - busy!')
            return
        }
        this.pollBusy = true
        let projects = await prosConnect.awaitGetProjects(true)
        if (this.mounted && projects) {
            // Check if requested sub-project been created
            prosConnect.prosLog('pollSubProjectReady()...')
            for (let project of projects) {
                if (project[ATTR_CUSTOMER_GROUP] === this.customerGroup &&
                    project[ATTR_MAIN_PROJECT_NAME] === this.mainProjectName &&
                    project[ATTR_TEXT] === this.state.projectName) {
                    this.setState({subProjectReadyInServer: true})
                    this.newSubProjectId = project.project_id
                    // prosConnect.prosLogX('SUB project in server ok')
                    prosConnect.prosLog('pollSubProjectReady() - stop polling project found')
                    this.stopPollingSubProjectReady()
                }
            }
        } else {
            prosConnect.prosLog('pollSubProjectReady() NOT MOUNTED!')
        }
        this.pollBusy = false
    }

    startPollingSubProjectReady() {
        this.stopPollingSubProjectReady()
        const POLL_PERIOD_SUB_PRJ_READY_MS = 2500
        this.pollTimer = setInterval(() => this.pollSubProjectReady(), POLL_PERIOD_SUB_PRJ_READY_MS)
    }

    stopPollingSubProjectReady(ui) {
        let self = ui || this
        if (self.pollTimer) {
            clearInterval(self.pollTimer)
        }
        self.pollTimer = undefined
    }

    async createNewSubProject() {
        if (this.state.copyContentFrom === 'template') {
            if (!this.nameLengthValid(this.state.projectName, PROJECT_NAME_MIN_LEN, this.maxProjectNameLen())) {
                return
            }
        }
        this.setState({ isSavingNewProject: true })
        let numOfRequestedSubProjects = await this.reqNewProjectFromServer()
        this.setState({
            isSavingNewProject: false
        })
        if (this.isMyProdectForMultipleUsers()) {
            // Super user ordered MyProdect projects
            prosNotificationShow(this, "MyProdect projektit tilattu")
        } else if (numOfRequestedSubProjects) {
            // TODO: Can we highlight new projects in projects list?
            if (numOfRequestedSubProjects === 1) {
                prosAppNotif('Uusi projekti luotu')
                this.props.switchToNewestProject()
            } else if (numOfRequestedSubProjects > 1) {
                prosAppNotif('Useita projekteja luotu')
                this.props.switchToReportView(0)
            }
        }
    }

    /**
     * Using UI selections request server to create one or more sub-projects.
     * @returns {Promise<number>}    Number of requested sub-projects
     */
    async reqNewProjectFromServer() {
        /*
        if (!prosConnect.hasPermissionTo("addProject", undefined, this.props.refProjectAttrs, false)) {
            prosNotificationShow(this, "Ei käyttöoikeutta luoda uutta projektia", true);
            return 0
        }
         */
        // New project is created to main project where ref project is
        // Main project name and customer group is same for new project as "main ref project" - in use to select these
        let refProject = this.props.refProjectAttrs
        this.mainProjectName = refProject[ATTR_MAIN_PROJECT_NAME]
        this.customerGroup = refProject[ATTR_CUSTOMER_GROUP]
        let copyObs = this.state.copyReports ? this.state.copyObs : false;

        if (this.state.copyContentFrom === "project") {
            if (this.state.newSubProjects.length < 1) {
                prosNotificationShow(this, "Valitse vähintään yksi lähdeprojekti", true)
                return 0
            }
            let count = 0
            for (let newProjectRef of this.state.newSubProjects) {
                await awaitMakeNewProject(this.mainProjectName, newProjectRef.newName,
                    newProjectRef.projectId, this.state.selectedUserProjectToMakeNewId, this.customerGroup,
                    this.state.copyReports, copyObs, this.state.copyOtherUsers, this.state.projectDesc)
                count += 1
            }
            this.startPollingSubProjectReady()
            return count
        } else {
            let refPidForSettings
            if (this.isMyProdectForMultipleUsers()) {
                refPidForSettings = prosConnect.getActiveProject().getPid()
            } else {
                if (this.state.copyContentFrom === "template") {
                    refPidForSettings = this.state.templateProjectId;
                }
            }
            if (refPidForSettings) {
                await awaitMakeNewProject(this.mainProjectName, this.state.projectName,
                    refPidForSettings, this.state.selectedUserProjectToMakeNewId, this.customerGroup,
                    this.state.copyReports, copyObs, this.state.copyOtherUsers, this.state.projectDesc)
                return 1
            } else {
                prosNotificationShow(this, "Lähdeprojektin valinta puuttuu", true);
                return 0
            }
        }
    }

    backToProject() {
        return <BasicButton
            btnClass={"primary"}
            label={"Poistu"}
            icon={"arrow-left"}
            action={()=>this.props.switchToReportView()}
        />
    }

    nameLengthValid(name, minLen, maxLen) {
        if (name.length < minLen) {
            prosNotificationShow(this, "Nimi liian lyhyt, vähintään " + minLen + " merkkiä");
            return false
        }
        if (name.length > maxLen) {
            prosNotificationShow(this, "Nimen pituus on rajoitettu " + maxLen + " merkkiin");
            return false
        }
        return true;
    }

    limitExceededAlert(len, maxLen, note) {
        if (len > maxLen) {
            prosNotificationShow(this, note + ", raja " + maxLen);
            return true
        }
        return false;
    }

    maxProjectNameLen() {
        return this.isMyProdectForMultipleUsers() ? 10000 : PROJECT_NAME_MAX_LEN
    }

    handleProjectName(val) {
        if (this.limitExceededAlert(val.length, this.maxProjectNameLen(), "Liian pitkä nimi")) {
            return
        }
        this.setState({
            projectName: prosConnect.filterSpecialChars(val)
        })
    }

    handleProjectDesc(val){
        this.setState({
            projectDesc: val
        })
    }

    isSubProjectSelected(project) {
        return this.state.newSubProjects
            .filter(proj => proj.projectId === project[ATTR_AWS_PROJECT_ID])
            .length > 0
    }

    toggleSubProjectAsSelected(project) {
        let updatedSubProjects
        if (this.isSubProjectSelected(project)) {
            // unselect -> remove
            updatedSubProjects = this.state.newSubProjects
                .filter(proj => proj.projectId !== project[ATTR_AWS_PROJECT_ID])
            if (updatedSubProjects.filter(proj => proj.is_template === STR_YES).length === 0) {
                this.setState({copyReports: false, copyObs: false})
            }
        } else {
            // select -> add
            if (project[ATTR_IS_TEMPLATE] === STR_YES) {
                this.setState({copyReports: true, copyObs: true})
            }
            updatedSubProjects = this.state.newSubProjects
                .concat({
                    projectId: project[ATTR_AWS_PROJECT_ID],
                    newName: project[ATTR_TEXT],
                    is_template: project[ATTR_IS_TEMPLATE]
                })
        }
        this.setState({ newSubProjects: updatedSubProjects })
    }

    renderProjectChoices() {
        let filteredList = this.state.mainProjectList[this.state.selectedMainProjectIndex].projects
            .filter(p => prosConnect.hasPermissionTo("editProject", undefined, p, false) ||
                p[ATTR_IS_TEMPLATE] === STR_YES)
        if(filteredList.length < 1) return <p>Projektilla ei ole kopioitavia osaprojekteja.</p>
        return filteredList
            .map((project, i) => {
                const isArchived = project[ATTR_PROJECT_STATE] === OBJ_STATE_PAS
                return <div key={i}
                        className={"display-flex" + (isArchived && " color-2nd")}
                        data-tooltip={isArchived ? "Voit kopioida myös arkistoidusta osaprojektista" : null}
                    >
                    <Checkbox
                        defaultChecked={this.isSubProjectSelected(project)}
                        text={project.text}
                        onChange={()=> this.toggleSubProjectAsSelected(project)}
                    />
                    {isArchived ? <span className={"icon-text-set-xs"}><i
                        className={"ui-icon ui-icon-sm ui-icon-outline-lock ui-icon_color-2nd"}/><span
                        className={"text-sm color-2nd"}>arkistoitu</span></span> : null}
                </div>
            })
    }

    renderUserTemplateDescription(text){
        if(!text) return null
        return <div className={"msg msg-hilite width-100 width-70_lg width-50_xxl"}>
            <h3>Kuvaus</h3>
            <p>{text}</p>
        </div>
    }

    renderSubProjectButton(item, i){
        return <BasicButton
            key={'__' + i}
            btnClass={"2nd"}
            label={item.text}
            selected={item.project_id === this.state.templateProjectId}
            action={() => {
                this.setState({ templateProjectId: item.project_id })
            }}
        >
            {item[ATTR_PROJECT_STATE] === OBJ_STATE_PAS
                ? <strong className={"icon-text-set-xs color-2nd margin-right"}>
                    <i className={"ui-icon ui-icon-outline-lock ui-icon-sm ui-icon_color-2nd"}/>
                    <span>arkistoitu</span>
                </strong> : null}
        </BasicButton>
    }
    renderCopyModelList() {
        let i = 0
        const listedExamples = []
        const userTemplates = []
        let subProjectDesctiptions = {}
        this.state.projectTemplates.forEach((item)=> {
            listedExamples.push(this.renderSubProjectButton(item, i))
            subProjectDesctiptions[item.project_id] = getObjAttr(item, ATTR_PRJ_DESC, '')
            i++
        })
        this.state.userTemplateProjects.forEach((item) => {
            i++
            userTemplates.push(this.renderSubProjectButton(item, i))
            subProjectDesctiptions[item.project_id] = getObjAttr(item, ATTR_PRJ_DESC, '')
        })
        return <>
            <div className={"inline-flex flex-gap-sm"}>
                <div>
                    {listedExamples.length > 0 ? <h4>Valmispohjat</h4> : null}
                    <div className={"tag-list"}>
                        {listedExamples}
                    </div>
                </div>
                {userTemplates.length > 0 ? <div>
                        <h4>Malliosaprojektit</h4>
                        <div className={"tag-list"}>
                            {userTemplates}
                        </div>
                    </div>: null }
            </div>
            {this.renderUserTemplateDescription(subProjectDesctiptions[this.state.templateProjectId])}
        </>
    }

    renderCopyProjectList(filterName) {
        let mainProjectsToChoose = this.getMainProjectMatching(this.state.mainProjectList, filterName)
        let totalProjectCount = this.state.mainProjectList.length-1
        let filteredProjectCount = mainProjectsToChoose.length-1
        const projectList = mainProjectsToChoose.map((mainProject)=> ({
            value: mainProject.origIndex,
            text: mainProject.name
        }))
        return  <>
            <div className={"element-set"}>
                <DropdownMenu
                    values={projectList}
                    currentValue={this.state.selectedMainProjectIndex}
                    onSelect={(val)=> {
                        this.setState({
                            selectedMainProjectIndex: val,
                            newSubProjects: []
                        })
                    }}
                    showFilter={projectList.length > UI_LISTED_ELEMENTS_LIMIT}
                    className={"flex-grow"}
                    required={!this.state.selectedMainProjectIndex}
                />
                {(this.state.filterProjectForRef.length > 0 ?
                    <span>{filteredProjectCount.toString()}/{totalProjectCount.toString()}</span> : null)}
            </div>
            <Spacer size={"lg"}/>
            {(this.state.mainProjectList[this.state.selectedMainProjectIndex].projects.length > 0 ?
                <>
                    <h3>Valitse kopioitavat osaprojektit</h3>
                    <div className={"selection-group selection-group-check"}>
                        {this.renderProjectChoices()}
                    </div>
                </> : null)}
        </>
    }

    renderCopyReportsChoice() {
        return <ToggleSwitch
            label={'Raportit'}
            checked={this.state.copyContentFrom === "project" ? this.state.copyReports : true}
            onChange={this.state.copyContentFrom === "report"
                ? () => this.setState({copyReports: true})
                    : this.state.copyReports ?
                        () => this.setState({copyReports: false, copyObs: false})
                            : () => this.setState({copyReports: !this.state.copyReports})
            }
            disabled={this.state.copyContentFrom === "template"}
        />
    }

    renderCopyObsChoice() {
        let notAllowedToChangeCopyObs = this.state.copyContentFrom === "template" || !this.state.copyReports
        return <ToggleSwitch
            label={'Kirjaukset'}
            checked={this.state.copyContentFrom === "project" ? this.state.copyObs : true}
            onChange={this.state.copyContentFrom === "report"
                ? () => this.setState({copyObs: true})
                    : !this.state.copyReports
                        ? () => this.setState({copyObs: false})
                            : () => this.setState({copyObs: !this.state.copyObs})
            }
            disabled={notAllowedToChangeCopyObs}
        />
    }

    renderCopyUserFromOtherProject() {
        return <ToggleSwitch
            label={'Tuo käyttöoikeudet toisesta osaprojektista'}
            checked={this.state.copyOtherUsers}
            onChange={() => this.setState({
                copyOtherUsers: !this.state.copyOtherUsers,
                copyUsers: false,
            })}
        />
    }

    getMainProjectMatching(mainProjectList, filterName) {
        let filter = this.state[filterName].toUpperCase()
        return mainProjectList
            .filter((mp, i) => mp.name.toUpperCase().includes(filter) || i === 0)
    }

    renderProjectListForOtherUsers(filterName) {
        if (!this.state.copyOtherUsers) {
            return null
        }
        let refProject = this.props.refProjectAttrs
        let refCustomerGroup = refProject[ATTR_CUSTOMER_GROUP]
        let customerMainProjects = this.state.mainProjectList
            .filter(mainProject =>
                mainProject.customerGroup === refCustomerGroup || // user admin only from same customer group
                !mainProject.customerGroup)                       // title project to show name in drop-down
        let mainProjectsToChoose = this.getMainProjectMatching(customerMainProjects, filterName)
        let totalProjectCount = customerMainProjects.length-1
        let filteredProjectCount = mainProjectsToChoose.length-1

        const projectList = mainProjectsToChoose
                .map(mainProject => ({
                        value: mainProject.origIndex,
                        text: mainProject.name
                    }))
        return <div className={"element-indented"}>
            <h3>Kopioi käyttäjät projektista</h3>
            <div className={"element-set"}>
                <DropdownMenu
                    values={projectList}
                    currentValue={this.state.selectedUserProjectIndex}
                    onSelect={(val)=> {
                        this.setState({
                            selectedUserProjectIndex: val,
                            selectedUserProjectToMakeNewId: undefined,
                        })
                    }}
                    showFilter={projectList.length > UI_LISTED_ELEMENTS_LIMIT}
                    required={!this.state.selectedUserProjectIndex}
                />
                {(this.state.filterProjectToCopyUsers.length > 0 ?
                    <span>{filteredProjectCount.toString()}/{totalProjectCount.toString()}</span> : null)}
            </div>
            <Spacer size={"lg"}/>
            {(this.state.mainProjectList[this.state.selectedUserProjectIndex].projects.length > 0 ?
                this.renderProjectListForOtherUsersList() : null)}
        </div>
    }

    renderProjectListForOtherUsersList(){
        if(!this.state.selectedUserProjectIndex) return null
        const subProjectsList = this.state.mainProjectList[this.state.selectedUserProjectIndex].projects
            .filter(p => prosConnect.hasPermissionTo("editAdmin", undefined, p, false))
            .map((project) => {
                return {
                    text: project[ATTR_TEXT],
                    value: project[ATTR_AWS_PROJECT_ID]
                }
        })
        return <>
            <h3>Valitse osaprojekti (valinnainen)</h3>
            <p>Voit halutessasi kopioida käyttäjät vain yhdestä osaprojektista.</p>
            <DropdownMenu
                currentValue={this.state.selectedUserProjectToMakeNewId}
                values={subProjectsList}
                onSelect={(val)=> this.setState({ selectedUserProjectToMakeNewId: val})}
                showFilter={subProjectsList.length > UI_LISTED_ELEMENTS_LIMIT}
            />
        </>
    }

    renderSaveButtons(saveTitle) {
        return <footer className="page-footer">
            <div className="btn-set_center">
                <CancelButton
                    action={()=> this.props.switchToReportView()}
                />
                <ConfirmButton
                    label={saveTitle}
                    action={()=> this.createNewSubProject()}
                    disabled={ ! this.isMyProdectForMultipleUsers() && ((this.state.copyContentFrom === 'template'
                        && (this.state.projectName.length < PROJECT_NAME_MIN_LEN
                            || this.state.projectName.length > PROJECT_NAME_MAX_LEN))
                        || (this.state.copyContentFrom !== 'template' ? !this.hasSelectedCopiedSubprojects() : false))
                    }
                />
            </div>
        </footer>
    }

    renderSavingProject() {
            if (this.state.isSavingNewProject) {
                return <LoadingAnimation size={"lg"} color={"var(--color-light)"} mask />
            }
    }

    closeCreateSubroject(ui) {
        prosPopupClose()
        ui.stopPollingSubProjectReady(ui)
        ui.props.switchToReportView()
    }

    /**
     * Notify about sub-project(s) been created.
     * User may press "Jatka" before server has created new sub-project(s) and updated user access rights.
     * Then user needs to press project list 'refresh projects' button.
     *
     * When user selects immediately a new sub-project that had lot of contents server may still be copying those
     * and user needs to refresh project data using "refresh data" - button.
     */
    dynamicPopupContentWaitingProject(ui) {
        if (ui.state.subProjectReadyInServer) {
            return <>
                <section>
                    <p>Osaprojekti on tehty, voit jatkaa.</p>
                </section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <ConfirmButton
                            label={"Valmis"}
                            action={()=> {
                                ui.props.doneCallback(ui.newSubProjectId)
                                prosPopupClose()
                            }}
                        />
                    </div>
                </footer>
            </>
        }
        return <section>
                <p>Osaprojektien tekeminen kestää hetken aikaa - tarkistetaan tilannetta...</p>
                <p>Voit myös jatkaa ja päivittää projektilistan myöhemmin.</p>
            </section>
    }

    openNotifyProjectPopup(mode) {
        if (mode === MODE_ONE_TEMPLATE_SUB_PROJECT) {
            prosPopupOpenDynamic(this, "Uusi osaprojekti",
                this.dynamicPopupContentWaitingProject, this.closeCreateSubroject)
            return
        }
        let waitSubProjectTitle
        let noteText
        if (mode === MODE_ONE_OR_MORE_SUB_PROJECTS) {
            waitSubProjectTitle = "Osaprojekti on tilattu"
            noteText =
                <>
                    <p>Pyyntö osaprojektin avaamisesta on lähetetty</p>
                    <p>Osaprojektien tekeminen saattaa kestää yli kymmenen sekuntia
                       kopioitavien tietojen määrästä riippuen.</p>
                    <p>Mikäli jokin uusista osaprojekteista ei heti näy projektilistassa saat sen
                       näkyviin päivittämällä listan.</p>
                </>
        } else { // MODE_MY_PRODECT
            waitSubProjectTitle = 'MyProdect projektit on tilattu'
            noteText = <p>Voit jatkaa</p>
        }
        prosPopupOpen(this,
            waitSubProjectTitle,
            <>
                <section>{noteText}</section>
                <footer className={"popup-footer"}>
                    <div className={"btn-set"}>
                        <BasicButton
                            btnClass={"primary"}
                            label={"Jatka"}
                            icon={"check"}
                            action={()=> this.closeCreateSubroject(this)}
                        />
                    </div>
                </footer>
            </>,
            () => this.closeCreateSubroject(this)
        )
    }

    isMyProdectForMultipleUsers() {
        // Superuser ordering MyProdect for multiple users
        let refProject = this.props.refProjectAttrs
        return refProject && refProject[ATTR_LICENSE_LEVEL] &&
            refProject[ATTR_LICENSE_LEVEL].indexOf('MyProdect') > -1 &&
            prosConnect.isSuperUserModeInUse()
    }

    isCopyUserAllowed() {
        return this.props.refProjectAttrs &&
           this.props.refProjectAttrs[ATTR_MAIN_PROJECT_NAME] &&
           this.props.refProjectAttrs[ATTR_MAIN_PROJECT_NAME].indexOf("MyProdect") < 0
    }

    isSubprojectNameValid(){
        if (this.state.copyContentFrom !== 'template') return true
        return this.state.projectName.length >= PROJECT_NAME_MIN_LEN
            && this.state.projectName.length <= PROJECT_NAME_MAX_LEN
    }

    renderSelectCopyUsers() {
        if(!this.isCopyUserAllowed()) return null//Todo Jere, tarkista toimiiko tama oikein...
        if(this.state.copyContentFrom === 'template' && !this.isSubprojectNameValid()) return null
        if(this.state.copyContentFrom === 'project' && !this.hasSelectedCopiedSubprojects()) return null
        return <>
            <Spacer size={"lg"}/>
            <h3>Käyttöoikeuksien kopiointi</h3>
            {this.renderCopyUserFromOtherProject()}
            <Spacer size={"lg"}/>
            {this.renderProjectListForOtherUsers('filterProjectToCopyUsers')}
        </>
    }

    renderSubprojectDescriptionInput(){
        if(!this.isSubprojectNameValid()){
            return null
        }
        return <TextInput
            label={"Osaprojektin kuvaus"}
            value={this.state.projectDesc}
            onChange={val => this.handleProjectDesc(val)}
            multiline={3}
            info={"Vapaehtoinen teksti"}
        />
    }

    renderCreateOneProject() {
        this.createModeForPopup = MODE_ONE_TEMPLATE_SUB_PROJECT
        return <>
            <div className="slab width-50_xl">
                <h3>Osaprojektin nimi</h3>
                <TextInput
                    value={this.state.projectName}
                    onChange={val => this.handleProjectName(val)}
                    required
                    isValid={this.isSubprojectNameValid()}
                    autoFocus
                    info={(this.state.projectName.length < PROJECT_NAME_MIN_LEN
                            ? "Minimipituus " + PROJECT_NAME_MIN_LEN + " merkkiä" : "")}
                />
                {this.renderSubprojectDescriptionInput()}
            </div>
            <div className={"slab width-50_xl"}>
                <h3>Valitse pohja</h3>
                {this.renderCopyModelList()}
                {this.renderSelectCopyUsers()}
            </div>
        </>
    }

    hasSelectedCopiedSubprojects(){
        return this.state.selectedMainProjectIndex && this.state.newSubProjects.length > 0
    }

    renderCopyChoices(){
        if(!this.hasSelectedCopiedSubprojects()) return null
        return <>
            <h3>Valitse osaprojektin asetusten lisäksi kopioitavat tiedot (valinnainen)</h3>
            <div className={"element-set-v"}>
                {this.renderCopyReportsChoice()}
                {this.renderCopyObsChoice()}
            </div>
        </>
    }

    renderCreateMultipleProjects() {
        this.createModeForPopup = MODE_ONE_OR_MORE_SUB_PROJECTS
        return <>
            <div className={"slab width-50_xl"}>
                <h3>Valitse projekti</h3>
                {this.renderCopyProjectList('filterProjectForRef')}
                <Spacer size={"lg"}/>
                {this.renderCopyChoices()}
                {this.renderSelectCopyUsers()}
            </div>
        </>
    }

    renderContent() {
        let refProject = this.props.refProjectAttrs
        if (this.isMyProdectForMultipleUsers()) {
            this.createModeForPopup = MODE_MY_PRODECT
            return <>
                <header className="page-header">
                    <h1>
                        {refProject.main_proj_name}
                    </h1>
                    {this.backToProject()}
                </header>
                <h2>Luo uusi osaprojekti</h2>
                <section className={"create-project create-subproject"}>
                    <div className="slab width-50_xl">
                        <p>MyProdect-osaprojektien luonti toisille käyttäjille.</p>
                        <TextInput
                            label={"MyProdect käyttäjien sähköpostiosoitteet:"}
                            value={this.state.projectName}
                            onChange={val => this.handleProjectName(val)}
                            autoFocus
                            required
                            isValid={isMultipleEmailsValid(this.state.projectName)}
                        />
                    </div>
                </section>
                {this.renderSaveButtons("Tee uudet MyProdect projektit")}
            </>
        }
        // Else normal sub-project to choose a template or ref project to copy settings from

        return <>
                <header className="page-header">
                    <h1>
                        Luo uusi osaprojekti
                        {refProject ? <p className={"margin-0 text"}>{refProject.main_proj_name}</p> : null}
                    </h1>
                    {this.backToProject()}
                </header>
                <h2>Vaihtoehdot</h2>
                <section className={"create-project create-subproject"}>
                    <div className={"slab width-50_xl"}>
                        <div className="selection-group selection-group-radio">
                            <RadioButton
                                checked={this.state.copyContentFrom === 'template'}
                                text="Yksi osaprojekti mallin mukaan"
                                onChange={() => {
                                    this.setState({
                                        copyContentFrom: 'template',
                                        copyReports: true,
                                        copyObs: true,
                                        copyUsers: false,
                                    })
                                }}
                            />

                            <RadioButton
                                checked={this.state.copyContentFrom === 'project'}
                                text="Kopioi projektista"
                                onChange={() => {
                                    this.setState({
                                        copyContentFrom: 'project',
                                        copyReports: false,
                                        copyObs: false,
                                        copyUsers: false,
                                    })
                                }}
                            />
                        </div>
                    </div>
                    {this.state.copyContentFrom === 'template' ? this.renderCreateOneProject() : null}
                    {this.state.copyContentFrom === 'project' ? this.renderCreateMultipleProjects() : null}
                </section>
                {this.state.copyContentFrom === 'template' ? this.renderSaveButtons("Tee osaprojekti") : null}
                {this.state.copyContentFrom === 'project' ? this.renderSaveButtons("Tee osaprojektit") : null}
            </>
    }

    render() {

            if (this.state.isLoading) {
                prosConnect.prosLogDt("CreateSubProject-render loading")
                return <LoadingAnimation size={"lg"} />
            }
        require("./assets/scss/CreateProject.scss")
        prosConnect.prosLogDt("CreateSubProject-render content")
        return (
            <>
                {this.renderContent()}
                {this.renderSavingProject()}
                {prosPopupRender(this, "CreateSubProject")}
            </>
        )
    }
}